<section class="sbnb-onboarding">
  <sbnb-user-header></sbnb-user-header>

  <article class="main">
    <!-- loading -->
    <mat-spinner *ngIf="loading" diameter="32"></mat-spinner>

    <!-- error -->
    <ng-container *ngIf="!loading && error">
      <h2 class="nomargin">{{ title }}</h2>
      <p>{{ error }}</p>

      <div style="margin-top: 48px">
        <sbnb-button
          *ngIf="!generatedAnotherToken"
          type="secondary"
          label="Return to login"
          [routerLink]="['/user/hello']"></sbnb-button>
      </div>
    </ng-container>

    <!-- happy state - click button to login -->
    <!-- we need a button to stop email clients auto-consuming tokens -->
    <ng-container *ngIf="!loading && !error">
      <h2 class="nomargin">Login to {{ 'CORE.PRODUCT_NAME' | transloco }}</h2>
      <p>{{ error }}</p>

      <div style="margin-top: 24px; width: 320px; display: flex; flex-direction: column; gap: 8px">
        <sbnb-button [fullWidth]="true" [loading]="loading" (clicked)="consumeToken(true)">
          Login and trust this device
        </sbnb-button>

        <sbnb-button type="secondary" [fullWidth]="true" [loading]="loading" (clicked)="consumeToken(false)">
          Login once
        </sbnb-button>
      </div>
    </ng-container>
  </article>

  <aside *ngIf="!loading && error">
    <div style="height: 563px; display: flex; align-items: flex-end; justify-content: center">
      <img src="/assets/images/login/forgot-pw.svg" />
    </div>
  </aside>
</section>
